import { Link } from "react-router-dom";
import { Rocket, ShoppingCart, BrainCircuit, TrendingUp, ArrowRight, CheckCircle2 } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import { Button } from "@/components/ui/button";

const SOLUTIONS = [
  { icon: Rocket, title: "Launch a new product", desc: "From idea to a polished MVP or full platform, with design, engineering and go-to-market baked in.", points: ["Rapid, structured discovery", "Design system + secure build", "Analytics & SEO from day one"] },
  { icon: ShoppingCart, title: "Sell more online", desc: "Conversion-optimized storefronts and funnels with secure checkout and product SEO.", points: ["High-converting storefront", "Payments-ready architecture", "Performance & product SEO"] },
  { icon: BrainCircuit, title: "Automate with AI", desc: "Remove repetitive work with responsible, logged AI workflows and assistants.", points: ["Smart lead routing", "AI content & assistants", "Retry-safe, audited workflows"] },
  { icon: TrendingUp, title: "Grow qualified traffic", desc: "Full-funnel marketing and technical SEO focused on measurable pipeline.", points: ["Technical + content SEO", "Multi-channel campaigns", "Conversion tracking & reporting"] },
];

export default function Solutions() {
  useSeo({ title: "Solutions", description: "Outcome-focused solutions from Buddy Solution: launch products, sell online, automate with AI and grow traffic." });
  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="Solutions" title="Solutions built around your goals"
        subtitle="We start with the outcome you want, then assemble the right mix of services to get you there." /></Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {SOLUTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.06}>
            <div className="flex h-full flex-col bs-card p-8">
              <div className="mb-4 inline-flex w-fit rounded-xl bg-primary/12 p-3 text-primary"><s.icon className="h-7 w-7" /></div>
              <h3 className="font-display text-xl font-bold">{s.title}</h3>
              <p className="mt-2 text-muted-foreground">{s.desc}</p>
              <ul className="mt-5 flex-1 space-y-2.5">
                {s.points.map((p) => <li key={p} className="flex items-start gap-2.5 text-sm"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-success" /> {p}</li>)}
              </ul>
              <Button asChild variant="outline" className="mt-6 w-fit rounded-full"><Link to="/consultation">Discuss this <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
